import { Notification } from "element-ui";
import VueCookies from "vue-cookies";
import router from "@/router/router";

// 錯誤msg消息提示
export const tip = (msg) => {
  Notification({
    title: "Error",
    dangerouslyUseHTMLString: true,
    message: msg,
    type: "error",
    duration: 2500
  });
};

//  跳轉回首頁，攜帶當前頁面路由，登入完成後跳轉回原本頁面
export const toLogin = () => {
  VueCookies.keys().forEach((cookie) => VueCookies.remove(cookie));
  if (localStorage.getItem("PLACE") === "/login") {
    router.push({ path: "/login" });
  } else if (localStorage.getItem("PLACE") === "/signIn") {
    router.push({ path: "/signIn" });
  } else {
    router.push({ path: "/" });
  }
};
